import React, { useState } from 'react';

import { Button } from 'react-bootstrap-5';
import { faFileExport, faLock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CallListExportModal from './modal';
import ExportUnavailable from './export_unavailable';
import { type DataExportTemplate } from 'bundles/connect/types';

type Props = {
  callListId: number,
  disabled?: string,
  templates: DataExportTemplate[]
}

export default function CallListExport({ disabled, callListId, templates }: Props) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ExportUnavailable disabled={disabled}>
        <div>
          <Button
            disabled={!!disabled}
            variant="text-primary"
            onClick={disabled ? undefined : () => setShowModal(true)}
          >
            <FontAwesomeIcon icon={disabled ? faLock : faFileExport}/>
            Export
          </Button>
        </div>

      </ExportUnavailable>
      <CallListExportModal
        callListId={callListId}
        show={showModal}
        templates={templates}
        onHide={() => setShowModal(false)}
      />
    </>
  );
}
